module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box box-primary box-solid"
  }, [_c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    directives: [{
      name: "permission",
      rawName: "v-permission.if",
      value: (['permission', 'createPermission']),
      expression: "['permission', 'createPermission']",
      modifiers: {
        "if": true
      }
    }],
    class: _vm.addButtonClass
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'PermissionCreate'
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary"
  }, [_vm._v("Add Permission")])])], 1), _vm._v(" "), _c('v-server-table', {
    ref: "permissionTable",
    attrs: {
      "url": "",
      "columns": _vm.columns,
      "options": _vm.options
    },
    on: {
      "row-click": _vm.rowClick,
      "loaded": _vm.onLoaded
    },
    scopedSlots: _vm._u([{
      key: "edit",
      fn: function(props) {
        return [_c('div', {
          staticClass: "active_wrp"
        }, [_c('a', {
          staticClass: "fa fa-edit",
          attrs: {
            "permission": "button"
          },
          on: {
            "click": function($event) {
              $event.stopPropagation();
              _vm.edit(props.row)
            }
          }
        })])]
      }
    }, {
      key: "child_row",
      fn: function(props) {
        return [_c('pre', [_c('code', [_vm._v(_vm._s(props.row))])])]
      }
    }])
  }, [_c('template', {
    slot: "beforeBody"
  }, [(_vm.loading) ? _c('tr', {
    staticClass: "VueTables__no-results"
  }, [_c('td', {
    staticClass: "text-center",
    attrs: {
      "colspan": "6"
    }
  }, [_c('pulse-loader')], 1)]) : _vm._e()])], 2)], 1)])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-9064286c", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-9064286c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/permissions/Permissions.vue
// module id = 2366
// module chunks = 0